module.exports = __webpack_public_path__ + "static/media/eyelashes08.20e20dca.jpg";